import Vue from "vue";
import app from "./app.vue";
import fastclick from "fastclick";
import "@/assets/js/common/kksa_kuaikanapp.js";
import h5init from "@kkmh/h5init";
import * as Sentry from "@sentry/browser";

import "@/assets/css/public/flex.css";
fastclick.attach(document.body);
window.h5init = h5init;
// Vue异常捕获，上报异常到sentry
Vue.config.errorHandler = function (err) {
    Sentry.captureException(err);
};

(async () => {
    // 提前请求 客户端协议 初始化window.__gvalkkmh
    await h5init({ login_mode: "unwanted" });
    new Vue({
        el: "#app",
        components: {
            app
        },
        template: "<app/>"
    });
})();


// WEBPACK FOOTER //
// ./src/pages/native/pay/vip/link_vip_multiple/index.js